import React from "react"
import SelectFilter from "../../atoms/select-filter/select-filter"
import Chip from "../../atoms/chip/chip"
import "./events-filters.scss"
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase';

const EventsFilters = ({
    filtersInfo,
    onClearFilters,
}) => {
    const [forceClose, setForceClose] = React.useState(false)

    return (
        <div className={"f-events-filters" + (forceClose ? " f-events-filters--open" : '')} onClick={() => forceClose && setForceClose(false)}>
            <h2 className="f-events-filters__title">FILTRAR POR</h2>
            <div className="f-events-filters-wrapper">
                {filtersInfo?.map(({ filterName, filterValues, filterState, onChangeFilter }, index) => {
                    return (
                        <SelectFilter
                            key={index}
                            title={filterName}
                            forceClose={forceClose}
                            setForceClose={setForceClose}
                        >
                            {filterValues.map((filter, index) => (
                                
                                (process.env.LOCALE!=='es-CO' && filter.name!=='Podcast' &&
                                (<Chip
                                    key={`f-filter-format-${index}`}
                                    slug={filter.slug || null}
                                    onClick={() => {
                                        !filter.slug &&
                                            onChangeFilter({
                                                key: filter.value,
                                                value: filter.name,
                                            })
                                    }}
                                    isActive={filterState.hasOwnProperty(filter.value)}
                                >
                                    {filter.name}
                                </Chip>)) ||
                                
                                (process.env.LOCALE==='es-CO' &&
                                <Chip
                                    key={`f-filter-format-${index}`}
                                    slug={filter.slug || null}
                                    onClick={() => {
                                        !filter.slug &&
                                            onChangeFilter({
                                                key: filter.value,
                                                value: filter.name,
                                            })
                                    }}
                                    isActive={filterState.hasOwnProperty(filter.value)}
                                >
                                    {filter.name}
                                </Chip>)
                            ))}
                        </SelectFilter>
                    )
                })}
            </div>
            <div className="f-events-filters-wrapper-mobile">
                <SelectFilter title="Filtrar por…" forceClose={forceClose} setForceClose={setForceClose}>
                    {filtersInfo?.map(({ filterName, filterValues, filterState, onChangeFilter }, index) => (
                        <div className="f-mobile-filter" key={index}>
                            <p className="f-mobile-filter__title">{filterName}</p>
                            {filterValues.map((filter, index) => (
                                
                                (process.env.LOCALE!=='es-CO' && filter.name!=='Podcast' &&
                                (<Chip
                                    key={`f-filter-format-${index}`}
                                    slug={filter.slug || null}
                                    onClick={() => {
                                        !filter.slug &&
                                            onChangeFilter({
                                                key: filter.value,
                                                value: filter.name,
                                            })
                                    }}
                                    isActive={filterState.hasOwnProperty(filter.value)}
                                >
                                    {filter.name}
                                </Chip>)) ||
                                
                                (process.env.LOCALE==='es-CO' &&
                                <Chip
                                    key={`f-filter-format-${index}`}
                                    slug={filter.slug || null}
                                    onClick={() => {
                                        !filter.slug &&
                                            onChangeFilter({
                                                key: filter.value,
                                                value: filter.name,
                                            })
                                    }}
                                    isActive={filterState.hasOwnProperty(filter.value)}
                                >
                                    {filter.name}
                                </Chip>)
                            ))}
                        </div>
                    ))}
                </SelectFilter>
            </div>

            <div className="f-events-filters-selected">
                <div className="f-events-filters-selected-wrapper">
                    {filtersInfo?.map(({ filterName, filterState, onChangeFilter, ...filter }, index) => (
                        Object.keys(filterState).length > 0 && (
                            <div className="f-events-filters-selected-type" key={index}>
                                <p className="f-events-filters-selected-type__title">
                                    {filterName}
                                </p>
                                <div>
                                    {Object.keys(filterState).map(key => (
                                        <Chip
                                            isCloseActive
                                            isActive
                                            onClick={() => {
                                                !filter.slug &&
                                                    onChangeFilter({
                                                        key,
                                                        value: filterState[key],
                                                    })
                                            }}
                                        >
                                            {filterState[key]}
                                        </Chip>
                                    ))}
                                </div>
                            </div>
                        )
                    ))}
                </div>
                {filtersInfo?.some(({filterState}) => Object.keys(filterState).length > 0)
                    && (
                        <div className="f-events-filters-button">
                            <button onClick={onClearFilters}>
                                {convertText('LIMPIAR FILTROS')}
                            </button>
                        </div>
                    )}
            </div>
        </div>
    )
}

export default EventsFilters
